export const FLAGGED_VITALS = ['bpSystolic', 'bpDiastolic', 'pulse', 'temperatureC', 'spo2', 'respiratoryRate', 'bloodSugarMgDl'];
export const VITAL_LIMITS = Object.freeze({
    bpSystolic: { low: 90, high: 160 },
    bpDiastolic: { low: 55, high: 100 },
    pulse: { low: 50, high: 110 },
    temperatureC: { low: 35, high: 38 },
    spo2: { low: 94 },
    respiratoryRate: { low: 10, high: 24 },
    bloodSugarMgDl: { low: 60, high: 300 },
});
export function vitalFlag(key, value) {
    if (!value)
        return null;
    const limits = VITAL_LIMITS[key];
    if (limits.low !== undefined && value < limits.low)
        return 'low';
    if (limits.high !== undefined && value > limits.high)
        return 'high';
    return null;
}
export function vitalsAbnormal(vitals) {
    return FLAGGED_VITALS.some((key) => vitalFlag(key, vitals[key]) !== null);
}
//# sourceMappingURL=vital-limits.js.map